import React from "react"

import Administrators from "../../Admin/AccountManager/Editor/Administrators"

const AdminEditor = ({ clientID, appID }) => {
  return <Administrators clientID={clientID} appID={appID} />
}

export default AdminEditor
